import { BillInterface } from '../../models/bill.interface';

export interface BillsInterfaceState {
  bills: Array<BillInterface>;
}

export const initialBillsState: BillsInterfaceState = {
  bills: null
};
